import { useState } from 'react'

import { makeTraceDetails } from 'common'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { useLocation } from 'react-router-dom'
import { Routes } from 'common/constants'

import { interWbNavigate } from '@interco/inter-webview-bridge'

import {
  IGetPrivacyPolicyAcceptanceContentResponse,
  TUsePrivacyPolicyAcceptanceSuccessReturn,
} from '../types'

const usePrivacyPolicyAcceptanceSuccess = (): TUsePrivacyPolicyAcceptanceSuccessReturn => {
  const [loading, setLoading] = useState(false)
  const location = useLocation()

  const { state } = location

  const deeplink: string = state?.deeplink ?? ''

  const content: IGetPrivacyPolicyAcceptanceContentResponse['content']['successFeedbackPage'] = {
    icon: state?.content?.icon ?? '',
    iconColor: state?.content?.iconColor ?? '',
    title: state?.content?.title ?? '',
    details: state?.content?.details ?? '',
    confirmButton: state?.content?.confirmButton ?? '',
  }

  const { icon, iconColor, title, details, confirmButton } = content

  const confirmButtonClickHandler = async () => {
    try {
      await sendSelectContent({
        flow: 'privacy_policy_acceptance_success',
        step: 'privacy_policy_acceptance_success',
        screen_name: Routes.PRIVACY_POLICY_ACCEPTANCE_SUCCESS,
        element_name: 'confirmOpenDeeplink',
        element_type: 'button',
        parent_name: 'PrivacyPolicyAcceptanceSuccess',
        scenario: JSON.stringify({
          screen: Routes.PRIVACY_POLICY_ACCEPTANCE_SUCCESS,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send privacy policy acceptance success confirm tic', error)
    }

    setLoading(true)
    setTimeout(() => {
      interWbNavigate.openDeepLink(deeplink)
      setLoading(false)
    }, 500)
  }

  const traceDetails = makeTraceDetails(true, content)

  useScreenFinishLoadTac({
    name: 'PrivacyPolicyAcceptanceSuccess',
    entity: undefined,
    action: 'PrivacyPolicyAcceptanceSuccess',
    screen: Routes.PRIVACY_POLICY_ACCEPTANCE_SUCCESS,
    shouldSend: true,
    logLabel: 'send privacy policy acceptance success tac',
  })

  return {
    icon: icon ?? 'core/status/ic_check_circle_fill',
    iconColor: iconColor ?? 'var(--success500)',
    title,
    details,
    loading,
    confirmButtonText: confirmButton,
    confirmButtonClickHandler,
    traceDetails,
  }
}

export { usePrivacyPolicyAcceptanceSuccess }
